import { create } from 'zustand';
import { tokenStorage } from '../lib/tokenStorage';
import analyticsService from '../services/analyticsService';
import type { User } from '../types/auth';

interface AuthState {
  isAuthenticated: boolean;
  user: User | null;
  token: string | null;
  loading: boolean;
  setAuth: (user: User, token: string) => void;
  setToken: (token: string) => void;
  setUser: (user: User) => void;
  setLoading: (loading: boolean) => void;
  logout: () => void;
  hydrate: () => void;
}

export const useAuthStore = create<AuthState>((set) => ({
  isAuthenticated: false,
  user: null,
  token: null,
  loading: true,

  setAuth: (user, token) => {
    set({ isAuthenticated: true, user, token, loading: false });
  },

  setToken: (token) => {
    set({ token });
  },

  setUser: (user) => {
    tokenStorage.setUser(user);
    set({ user });
  },

  setLoading: (loading) => set({ loading }),

  logout: () => {
    analyticsService.track('logout');
    analyticsService.reset();
    tokenStorage.clearAll();
    set({ isAuthenticated: false, user: null, token: null, loading: false });
  },

  hydrate: () => {
    const token = tokenStorage.getAccessToken();
    const user = tokenStorage.getUser();

    if (token && user) {
      set({ isAuthenticated: true, user, token, loading: false });
      analyticsService.identify(user.id, { email: user.email, role: user.role });
    } else {
      set({ loading: false });
    }
  },
}));
